import { render, staticRenderFns } from "./EcommerceList.vue?vue&type=template&id=3a1d1c8e"
import script from "./EcommerceList.vue?vue&type=script&lang=js"
export * from "./EcommerceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports